module.exports = __webpack_public_path__ + "img/27f753c.jpg";